module.exports = __webpack_public_path__ + "static/img/brand-bg@w.db39a30.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/d-steady/brand-bg@w.png
// module id = 5Oh4
// module chunks = 0